import { LinkspaceSection, PageTypeEnum } from '@app/enums';
import {
    BreadcrumbsModel,
    EsResponseManyModel,
    LinkspaceDocumentModel,
    LinkspaceModel,
    LinkspaceTagModel,
} from '@app/models/elastic-search';

export interface LinkspaceSectionConfig {
    docId: PageTypeEnum;
    sectionId: LinkspaceSection;
    limit?: number;
    prependLink?: LinkspaceTagModel;
}

const ACCOMMODATION_CITY_BREADCRUMB_INDEX = 2;
const ACCOMMODATION_CITY_CATEGORY_BREADCRUMB_INDEX = 3;

export const getLinksBySections = (
    hits: EsResponseManyModel<LinkspaceDocumentModel>['hits'],
    sectionConfig: LinkspaceSectionConfig[],
) => {
    const mappedSections: LinkspaceModel[] = [];

    sectionConfig.forEach(config => {
        const doc = hits.find(hit => hit._source.pageType === config.docId);
        const section = doc?._source.sections.find(section => section.id === config.sectionId);

        if (!section) {
            return;
        }

        const links = config.prependLink ? [config.prependLink, ...section.links] : section.links;

        mappedSections.push({
            id: section.id,
            title: section.name,
            tags: config.limit ? links.slice(0, config.limit) : links,
        });
    });

    return mappedSections;
};

export const getAccommodationLinkspaces = (
    linkspaceDetails: EsResponseManyModel<LinkspaceDocumentModel> | null,
    breadcrumbs: BreadcrumbsModel,
) => {
    if (!linkspaceDetails?.hits) {
        return undefined;
    }

    const getBreadcrumbLink = (index: number) => {
        return breadcrumbs?.items?.[index]
            ? {
                  name: breadcrumbs.items[index].name,
                  url: breadcrumbs.items[index].item,
              }
            : undefined;
    };

    const sectionConfig = [
        {
            docId: PageTypeEnum.City,
            sectionId: LinkspaceSection.CityPopularNearby,
            limit: 30,
            prependLink: getBreadcrumbLink(ACCOMMODATION_CITY_BREADCRUMB_INDEX),
        },
        {
            docId: PageTypeEnum.CityCategory,
            sectionId: LinkspaceSection.CityCategoryPopularNearby,
            limit: 15,
            prependLink: getBreadcrumbLink(ACCOMMODATION_CITY_CATEGORY_BREADCRUMB_INDEX),
        },
        {
            docId: PageTypeEnum.City,
            sectionId: LinkspaceSection.CityRegion,
            limit: 15,
        },
        {
            docId: PageTypeEnum.City,
            limit: 9,
            sectionId: LinkspaceSection.CityCategory,
        },
        {
            docId: PageTypeEnum.City,
            sectionId: LinkspaceSection.CityPictogram,
            limit: 6,
        },
        {
            docId: PageTypeEnum.City,
            sectionId: LinkspaceSection.CityAdaptedOptions,
        },
    ];

    return getLinksBySections(linkspaceDetails.hits, sectionConfig);
};
